<template>
    <v-container fluid fill-height px-0 class="main-container d-block">
        <div class="content-block">
            <HeaderMenu title="История включения/выключения света" class="mx-6 mb-6" back-page/>
            <v-layout row v-if="deviceData" class="bold-text mx-6 mb-3 w-100 justify-center">
                {{ deviceData.name }}
                <span class="subtitle-text ml-1" v-if="deviceData.location">
                    ({{ deviceData.location }})
                </span>
            </v-layout>
            <v-layout column ma-0 class="main-text mb-5 w-100 history-list scrollbar-block" v-if="lightings.length > 0">
                <v-flex
                    xs12
                    v-for="(lighting, index) in lightings"
                    :key="index" class="history"
                    :class="{'history__high': lighting.new_day}"
                >
                    <v-layout v-if="lighting.new_day" class="history__title bold-text">
                        {{lighting.new_day}}
                    </v-layout>
                    <v-flex class="history-row">
                        <div class="history-row__time">
                            <div class="d-flex align-center">
                                <div class="d-inline-flex" v-if="lighting.state.value">
                                    <v-img max-height="30px" max-width="30px" :src="require('@/assets/device-icons/lighting.svg')" class="d-inline-flex"/>
                                </div>
                                <div class="d-inline-flex" v-else>
                                    <v-img max-height="30px" max-width="30px" :src="require('@/assets/device-icons/lighting_off.svg')" class="d-inline-flex"/>
                                </div>
                                <div class="time-row bold-text d-inline-flex ml-2">
                                    время: <span class="main-text ml-1">{{lighting.start_updated}}</span>
                                </div>
                            </div>
                        </div>
                    </v-flex>
                </v-flex>
            </v-layout>
            <div class="d-flex align-center history-list__error" v-else>
                <v-flex class="d-block text-center">
                    <div>
                        <v-img :src="require('@/assets/images/error.svg')" class="d-inline-flex mb-8"/>
                        <div class="common-text text-center">
                            Нет истории
                        </div>
                    </div>
                </v-flex>
            </div>
            <ModalWaiting ref="modalWaiting" title="Загрузка событий" noCancel></ModalWaiting>
        </div>
    </v-container>
</template>

<script>
import HeaderMenu from "@/components/core/HeaderMenu";
import ModalWaiting from "@/components/modals/ModalWaiting";
import {eventBus} from "@/main";
import {getTimeFromDate} from "@/utils";

export default {
    name: "LightingHistory",
    components: {
        HeaderMenu,
        ModalWaiting,
    },
    data() {
        return {
            deviceUID: null,
            deviceData: {},
            lightings: [],
        };
    },
    created() {
        eventBus.$on("reconnect", this.loadPage);
    },
    beforeDestroy() {
        eventBus.$off("reconnect", this.loadPage);
    },
    mounted() {
        this.loadPage();
    },
    methods: {
        loadPage() {
            this.deviceUID = this.$route.params.id;
            if (this.deviceUID) {
                this.getLightings();
            }
        },
        getLightings() {
            this.lightings = [];
            this.$refs.modalWaiting.open();
            this.$http.get('/devices/guest/lighting-on-off-history/' + this.deviceUID + '/')
                .then((res) => {
                    this.deviceData = res.data.device;
                    this.lightings = res.data.actions;
                    this.lightings.forEach((lighting, index) => {
                        lighting.start_updated = this.getTime(lighting.date);
                        if (index > 0) {
                            if (this.checkDay(lighting.date) != this.checkDay(this.lightings[index - 1].date)) {
                                lighting.new_day = this.checkDay(lighting.date);
                                lighting.new_day = this.reverseDate(lighting.new_day);
                            }
                        } else {
                            lighting.new_day = this.checkDay(lighting.date);
                            lighting.new_day = this.reverseDate(lighting.new_day);
                        }
                    });
                })
                .finally(() => {
                    this.$refs.modalWaiting.close();
                });
        },
        getTime(time) {
            return getTimeFromDate(time);
        },
        checkDay(day) {
            return day.split(' ')[0];
        },
        reverseDate(time) {
            const [year, month, day] = time.split("-");
            return day + "." + month + "." + year;
        },
    },
}
</script>